import PublicHeader from "@/components/PublicHeader";

export default function Privacy() {
    return (
        <div className="min-h-screen">
            <PublicHeader />
            <article className="max-w-3xl mx-auto pt-32 pb-24 px-6 sm:px-8">
                <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#86868B] mb-3">Document légal</p>
                <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight text-[#1D1D1F]">
                    Politique de confidentialité
                </h1>
                <p className="mt-3 text-sm text-[#86868B]">Dernière mise à jour : 18 février 2026 · Conforme RGPD</p>

                <Section title="Responsable du traitement">
                    <p>
                        Ticketify SAS — RCS Paris — Adresse&nbsp;: 12 rue de la Numérisation, 75001 Paris.
                        Délégué à la protection des données&nbsp;:{" "}
                        <a href="mailto:dpo@ticketify.fr" className="text-[#007AFF] hover:underline">
                            dpo@ticketify.fr
                        </a>
                    </p>
                </Section>

                <Section title="Données collectées">
                    <ul className="list-disc pl-6 space-y-1.5">
                        <li>Identité&nbsp;: nom, prénom, email, téléphone (facultatif)</li>
                        <li>Données bancaires&nbsp;: relevés CSV importés ou connexion lecture seule</li>
                        <li>Justificatifs&nbsp;: e-reçus extraits de votre boîte mail (sur consentement), photos
                            de tickets soumises par vous</li>
                        <li>Données techniques&nbsp;: adresse IP, logs de connexion, type de navigateur</li>
                        <li>Paiement&nbsp;: traité directement par Stripe — nous ne stockons aucune donnée carte</li>
                    </ul>
                </Section>

                <Section title="Finalités">
                    <ul className="list-disc pl-6 space-y-1.5">
                        <li>Fournir le Service&nbsp;: extraction, matching et archivage des justificatifs</li>
                        <li>Gestion de votre compte et facturation</li>
                        <li>Support client et amélioration du Service</li>
                        <li>Respect des obligations légales (conservation comptable art. L102 B LPF)</li>
                    </ul>
                </Section>

                <Section title="Base légale">
                    <p>
                        Exécution du contrat (CGU), consentement explicite (connexion Gmail), intérêt
                        légitime (sécurité, prévention fraude), obligation légale (conservation comptable).
                    </p>
                </Section>

                <Section title="Durée de conservation">
                    <ul className="list-disc pl-6 space-y-1.5">
                        <li>Compte actif&nbsp;: durée de l&apos;abonnement</li>
                        <li>Justificatifs comptables&nbsp;: 10 ans (art. L102 B LPF)</li>
                        <li>Logs techniques&nbsp;: 1 an</li>
                        <li>Compte supprimé&nbsp;: anonymisation sous 30 jours, sauf obligations légales</li>
                    </ul>
                </Section>

                <Section title="Hébergement et sécurité">
                    <p>
                        Toutes les données sont hébergées en France chez un prestataire certifié ISO&nbsp;27001
                        et HDS. Chiffrement TLS 1.3 en transit, AES-256 au repos. Sauvegardes quotidiennes,
                        accès journalisé.
                    </p>
                </Section>

                <Section title="Vos droits (RGPD)">
                    <p>Vous disposez à tout moment des droits suivants&nbsp;:</p>
                    <ul className="list-disc pl-6 space-y-1.5">
                        <li><strong>Accès</strong> (art. 15)&nbsp;: consulter vos données</li>
                        <li><strong>Rectification</strong> (art. 16)&nbsp;: corriger toute donnée inexacte</li>
                        <li><strong>Effacement</strong> (art. 17)&nbsp;: supprimer votre compte et données</li>
                        <li><strong>Portabilité</strong> (art. 20)&nbsp;: exporter toutes vos données au format JSON</li>
                        <li><strong>Opposition / limitation</strong> (art. 21-22)</li>
                        <li><strong>Réclamation</strong> auprès de la CNIL&nbsp;:{" "}
                            <a href="https://www.cnil.fr" target="_blank" rel="noreferrer" className="text-[#007AFF] hover:underline">
                                www.cnil.fr
                            </a>
                        </li>
                    </ul>
                    <p>
                        L&apos;export et la suppression de votre compte sont disponibles dans{" "}
                        <a href="/app/account" className="text-[#007AFF] hover:underline">Paramètres &gt; Profil</a>.
                    </p>
                </Section>

                <Section title="Cookies">
                    <p>
                        Nous utilisons uniquement des cookies essentiels au fonctionnement du Service
                        (session, préférences). Aucun cookie publicitaire ou de tracking tiers n&apos;est
                        déposé sans votre consentement explicite.
                    </p>
                </Section>

                <Section title="Sous-traitants">
                    <ul className="list-disc pl-6 space-y-1.5">
                        <li>Stripe (paiement) — données carte traitées hors UE avec garanties appropriées</li>
                        <li>Google (OAuth Gmail) — consentement explicite requis</li>
                        <li>OpenAI (OCR via GPT-5.2) — données chiffrées, pas d&apos;entraînement modèle</li>
                        <li>Resend (envoi d&apos;emails transactionnels) — UE</li>
                    </ul>
                </Section>

                <Section title="Contact">
                    <p>
                        Pour toute question relative à vos données&nbsp;:{" "}
                        <a href="mailto:dpo@ticketify.fr" className="text-[#007AFF] hover:underline">
                            dpo@ticketify.fr
                        </a>
                    </p>
                </Section>
            </article>
            <Footer />
        </div>
    );
}

function Section({ title, children }) {
    return (
        <section className="mt-10">
            <h2 className="text-xl sm:text-2xl font-semibold tracking-tight text-[#1D1D1F] mb-3">{title}</h2>
            <div className="space-y-3 text-[15px] leading-relaxed text-[#1D1D1F]/90">{children}</div>
        </section>
    );
}

function Footer() {
    return (
        <footer className="border-t border-black/5 py-10 px-6 sm:px-8 text-center text-sm text-[#86868B]">
            © 2026 Ticketify · <a href="/cgu" className="hover:text-[#1D1D1F]">CGU</a> ·{" "}
            <a href="/mentions-legales" className="hover:text-[#1D1D1F]">Mentions légales</a>
        </footer>
    );
}
